<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div v-if="formData.hasOwnProperty('id')" class="col-12 q-px-sm">
        <q-btn
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          :loading="impersonatingUser"
          @click="impersonateUser"
          v-if="currentUserData.role == 'superAdmin'"
        >
          <q-icon size="xs" name="mdi-account" class="q-mr-sm"></q-icon>
          Impersonate User
        </q-btn>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.email"
          label="Email Address"
          :rules="[
            (v) => !!v || 'Email is required',
            (v) => /.+@.+/.test(v) || 'Email must be valid',
          ]"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.name"
          label="Name"
          :rules="[(v) => !!v || 'Name is required']"
        ></q-input>
      </div>
      <div v-if="formData.hasOwnProperty('id')" class="col-12 q-px-sm">
        <assignApplication
          :id="formData.applicationsAdminOf"
          label="Applications Admin Of"
          multiple
          @changed="(val) => (formData.applicationsAdminOf = val)"
        />
      </div>
      <div v-if="formData.hasOwnProperty('id')" class="col-12 q-px-sm">
        <assignOrganization
          :id="formData.organizationsAdminOf"
          label="Organizations Admin Of"
          multiple
          @changed="(val) => (formData.organizationsAdminOf = val)"
        />
      </div>
      <div v-if="formData.hasOwnProperty('id')" class="col-12 q-px-sm">
        <assignOrganization
          :id="formData.organizationsUserOf"
          label="Organizaiton User Of"
          multiple
          @changed="(val) => (formData.organizationsUserOf = val)"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignApplication from "@/components/applications/assignApplication.vue";
  import assignOrganization from "@/components/organizations/assignOrganization.vue";

  export default {
    components: {
      assignApplication,
      assignOrganization,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
      }),
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},

      impersonatingUser: false,
    }),
    beforeCreate() {
      this.$store.dispatch("applications/loadAll");
      this.$store.dispatch("organizations/loadAll");
    },
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          if (this.currentUserData == "Admin") {
            this.roles = [
              {
                label: "Admin",
                value: "Admin",
              },
              {
                label: "Organization Admin",
                value: "OrgAdmin",
              },
              {
                label: "Organization User",
                value: "OrgUser",
              },
            ];
          }
        } else {
          this.formData = {};
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.form.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("users/newUser", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$emit("close", true);
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: result.Response.Message,
                    });
                  }
                });
            } else {
              this.$emit("loadingStateChanged", false);
            }
          });
        }, 200);
      },
      save() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store.dispatch("users/saveUser", this.formData).then((result) => {
            this.$emit("loadingStateChanged", false);
            console.log(result);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "User has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        });
      },
      resetTemporaryPassword() {
        this.$q.notify({
          message:
            "Resetting a Temporary password will delete the users current password.",
          color: "warning",
          position: "center",
          timeout: 0,
          actions: [
            {
              label: "Reset Password",
              color: "red",
              handler: () => {
                this.$store.dispatch("users/resetUserTempPassword", {
                  id: this.formData.id,
                  username: this.formData.username,
                });
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message:
                    "The user has been emailed their new Temporary password",
                });
              },
            },
          ],
        });
      },
      impersonateUser() {
        this.impersonatingUser = true;
        this.$store
          .dispatch("auth/impersonate", { id: this.formData.id })
          .then((result) => {
            this.impersonatingUser = false;
            this.$router.push("/dashboard");
          });
      },
    },
  };
</script>
